<template>
  <CreateEditStepModal
    v-if="showCreateEditStepModal"
    :projectId="projectId"
    :stepId="stepIdSelected"
    @closeModal="closeModal"
  />
  <DeleteStepModal
    v-if="showDeleteStepModal"
    :projectId="projectId"
    :stepId="stepIdSelected"
    @closeModal="closeModal"
  />
  <EditOrdemStepsModal
    v-if="showEditOrdemStepsModal"
    :projectId="projectId"
    :steps="steps"
    @closeModal="closeModal"
  />
  <LoadingData v-if="loadData" />
  <div v-else class="card">
    <div class="card-header d-flex align-items-center py-0">
      <h6 class="py-3 mb-0">Etapas</h6>
      <div v-if="canEditProject" class="mx-2">
        <div class="form-check">
          <input
            type="checkbox"
            id="enabledOrder"
            class="form-check-input"
            v-model="enabledOrder"
          />
          <label class="form-check-label" for="enabledOrder">
            Habilitar Ordenação
          </label>
        </div>
      </div>
      <button
        v-if="enabledOrder"
        type="button"
        class="btn btn-sm btn-link"
        title="Cancelar"
        @click="cancelEditOrdemSteps()"
      >
        Cancelar
      </button>
      <button
        v-if="enabledOrder"
        type="button"
        class="btn btn-sm btn-teal ms-2"
        title="Salvar Ordenação"
        @click="showEditOrdemStepsModal = true"
      >
        Salvar
      </button>
      <div v-if="canEditProject" class="ms-auto">
        <button
          type="button"
          class="btn btn-sm btn-primary"
          title="Adicionar Etapa ao Sumário Executivo"
          @click="createEditStep()"
        >
          Adicionar Etapa
        </button>
      </div>
    </div>
    <div v-if="steps.length > 0" class="table-responsive">
      <table class="table table-sm table-striped">
        <thead>
          <tr>
            <th v-if="enabledOrder" class="w-2"></th>
            <th class="text-center">Ordem</th>
            <th>Atividade</th>
            <th>Detalhamento</th>
            <th>Responsável</th>
            <th v-if="canEditProject" class="text-center actions">Ações</th>
          </tr>
        </thead>
        <draggable v-model="steps" tag="tbody" :disabled="!enabledOrder">
          <transition-group>
            <tr v-for="step in steps" :key="step.id">
              <td v-if="enabledOrder">
                <span class="cursor-move">
                  <i class="ph-arrows-out-cardinal"></i>
                </span>
              </td>
              <td class="text-center">{{ step.order }}</td>
              <td>{{ step.title }}</td>
              <td>{{ step.description }}</td>
              <td>{{ step.responsible }}</td>
              <td v-if="canEditProject" class="text-center">
                <button
                  type="button"
                  class="btn btn-outline-danger btn-icon rounded-pill"
                  title="Excluir"
                  @click="deleteStep(step.id)"
                >
                  <i class="ph-trash" />
                </button>
                <button
                  type="button"
                  class="btn btn-outline-warning btn-icon rounded-pill ms-2"
                  title="Editar"
                  @click="createEditStep(step.id)"
                >
                  <i class="ph-pencil" />
                </button>
              </td>
            </tr>
          </transition-group>
        </draggable>
      </table>
    </div>
    <div v-else class="card-body text-center">
      <p class="mb-0">
        Este sumário executivo não possui nenhuma etapa cadastrada
      </p>
    </div>
  </div>
</template>

<script>
import CreateEditStepModal from '@/components/projects/steps/CreateEditStepModal.vue'
import DeleteStepModal from '@/components/projects/steps/DeleteStepModal.vue'
import EditOrdemStepsModal from '@/components/projects/steps/EditOrdemStepsModal.vue'
import LoadingData from '@/components/commons/LoadingData.vue'
import { mapGetters } from 'vuex'
import { VueDraggableNext } from 'vue-draggable-next'

export default {
  name: 'StepsProject',

  components: {
    CreateEditStepModal,
    DeleteStepModal,
    EditOrdemStepsModal,
    LoadingData,
    draggable: VueDraggableNext,
  },

  props: {
    projectId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      loadData: true,
      showCreateEditStepModal: false,
      showDeleteStepModal: false,
      showEditOrdemStepsModal: false,
      enabledOrder: false,
      steps: {},
      stepIdSelected: null,
    }
  },

  computed: {
    ...mapGetters(['canEditProject']),
  },

  methods: {
    async getSteps() {
      try {
        this.steps = await this.$store.dispatch(
          'getProjectSteps',
          this.projectId,
        )
        this.loadData = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    createEditStep(stepId) {
      this.stepIdSelected = stepId || null
      this.showCreateEditStepModal = true
    },

    deleteStep(stepId) {
      this.stepIdSelected = stepId
      this.showDeleteStepModal = true
    },

    cancelEditOrdemSteps() {
      this.enabledOrder = false
      this.getSteps()
    },

    closeModal(loadListSteps) {
      if (loadListSteps) {
        this.getSteps()
      }
      this.showCreateEditStepModal = false
      this.showDeleteStepModal = false
      this.showEditOrdemStepsModal = false
      this.enabledOrder = false
    },
  },

  mounted() {
    this.getSteps()
  },
}
</script>

<style scoped>
.w-2 {
  width: 2%;
}
</style>
